import types from './types';

const SESSION_KEY = '_nscorporate_servicedesk';

export const initialState = {
  calledFilter: {},
  calledResult: {
    result: [],
    lastPage: 1,
    currentPage: 0,
    lastListSize: 0,
    itemsPerPage: 5
  },
  dashboardFilter: {
    filtroGraficoPeriodoLegado: {
      date: '',
      dataset: {
        aberto: false,
        encerrado: false,
      },
    },
    filtroGraficoTipoChamado: { modulo: '', tipoChamado: '' },
    filtroGraficoSLAAtendimentoEncerrados: { modulo: '', prioridade: '' },
    filtroGraficoSLAAtendimentoStatus: { status: '' },
    filtroGraficoSLAAtendimentoAplicacao: {
      aplicacao: '',
      dataset: {
        tempoMedioAtendimento: false,
        dentroSLA: false,
        foraSLA: false,
      },
    },
    filtroGraficoSLAAtendimentoTipo: {
      tipo: '',
      dataset: {
        tempoMedioAtendimento: false,
        dentroSLA: false,
        foraSLA: false,
      },
    },
  },
};

const sessionState = sessionStorage.getItem(SESSION_KEY);
const STATE = sessionState ? JSON.parse(sessionState) : initialState;

export default (state = STATE, action) => {
  switch (action.type) {
    case types.SET_CALLED_FILTER:
      state.calledFilter = action.payload;
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
      return { ...state };

    case types.CLEAR_CALLED_FILTER:
      state.calledFilter = initialState.calledFilter;
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
      return { ...state };

    case types.SET_CALLED_RESULT:
      state.calledResult = action.payload;
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
      return { ...state };

    case types.SET_DASHBOARD_DATA:
      state.dashboardFilter = {
        ...state.dashboardFilter,
        ...action.payload,
      };

      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
      return { ...state };

    default:
      return state;
  }
};
